@if (footer) {
  <div class="container-fluid back-body">
    @for (layout of footer?.templates; track layout; let i = $index) {
      <div>
        @switch (layout?.typeOf) {
          @case ('col-1') {
            <col-1 [index]="i" [components]="$safeNavigationMigration(layout?.components)"></col-1>
          }
          @case ('col-21') {
            <col-21 [index]="i" [templates]="$safeNavigationMigration(layout?.components)"></col-21>
          }
          @case ('col-2-1-2') {
            <col-2-1-2
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-2-1-2>
          }
          @case ('col-2-1-3') {
            <col-2-1-3
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-2-1-3>
          }
          @case ('col-2-2-1') {
            <col-2-2-1
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-2-2-1>
          }
          @case ('col-2-3-1') {
            <col-2-3-1
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-2-3-1>
          }
          @case ('col-31') {
            <col-31 [index]="i" [templates]="$safeNavigationMigration(layout?.components)"></col-31>
          }
          @case ('col-3-1-1-2') {
            <col-3-1-1-2
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-3-1-1-2>
          }
          @case ('col-3-1-2-1') {
            <col-3-1-2-1
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-3-1-2-1>
          }
          @case ('col-3-2-1-1') {
            <col-3-2-1-1
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-3-2-1-1>
          }
          @case ('col-421') {
            <col-421
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-421>
          }
          @case ('col-632') {
            <col-632
              [index]="i"
              [templates]="$safeNavigationMigration(layout?.components)"
            ></col-632>
          }
          @default {
            <div></div>
          }
        }
      </div>
    }
  </div>
}

@if (configService?.versionNumber !== '') {
  <div class="ag-pa-sm back-body" style="text-align: right">
    {{ configService?.versionNumber }}
  </div>
}
